// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-5648c5ba]{margin-top:60px}.align-buttons[data-v-5648c5ba],.align-gen[data-v-5648c5ba]{text-align:center}.align-buttons[data-v-5648c5ba]{margin:30px 0}.scan-button[data-v-5648c5ba]{margin:6px 0;font-size:16px;font-style:italic;color:#837d89}", ""]);
// Exports
module.exports = exports;
